import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Components from "../../../components/all";

import { RxOpenInNewWindow } from "react-icons/rx";

export default function RevenueAllPS() {
	const navigate = useNavigate();
	// eslint-disable-next-line no-unused-vars
	const [loading, setLoading] = useState(false);

	// All Parking Spaces Data
	var allPsData = {
		allData: [
			{
				id: 1,
				name: "Comsats University Islamabad",
				city: "Islamabad",
			},
			{
				id: 2,
				name: "University Islamabad",
				city: "Islamabad",
			},
			{
				id: 3,
				name: "Islamabad",
				city: "Islamabad",
			},
			{
				id: 4,
				name: "Comsats University Islamabad",
				city: "Islamabad",
			},
			{
				id: 5,
				name: "University Islamabad",
				city: "Islamabad",
			},
			{
				id: 6,
				name: "Islamabad",
				city: "Islamabad",
			},
			{
				id: 7,
				name: "Comsats University Islamabad",
				city: "Islamabad",
			},
			{
				id: 8,
				name: "University Islamabad",
				city: "Islamabad",
			},
			{
				id: 9,
				name: "Islamabad",
				city: "Islamabad",
			},
		],
	};

	// Search Feature
	const [filteredPS, setFilteredPS] = useState([]);
	const [searchValue, setSearchValue] = useState("");
	const search = (term) => {
		setSearchValue(term);
		const filtered = allPsData.allData.filter(
			(x) => x.name.toLowerCase().indexOf(term.toLowerCase()) > -1
		);
		setFilteredPS(filtered);
	};

	return loading === true ? (
		<Components.Loader />
	) : (
		<div
			className="AllParkingSpaces
            overflow-hidden 
            h-full
            w-full
            sm:p-3 md:p-5
			flex items-stretch
			"
		>
			{/* card 1 */}
			<div
				style={{
					boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
				}}
				className="
					w-full
					p-4 md:p-8 m-2
					overflow-x-hidden
					overflow-y-auto
                    rounded-md
                    bg-white 
                    flex flex-col items-stretch
                    duration-150 ease-in-out
                    "
			>
				{/* heading */}
				<div
					className="
							w-full
							pb-5 
							flex 
							items-center 
							flex-wrap
							"
				>
					<Components.BackButton />

					<div className="">
						<h1 className="text-lg">Parking Spaces List</h1>
						<h1 className="text-dark text-sm">
							Search Parking Spaces From The List
						</h1>
					</div>
				</div>

				{/* search */}
				<div className="mb-2">
					<div className="relative mt-1">
						<div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
							<svg
								className="w-5 h-5 text-gray-500"
								aria-hidden="true"
								fill="currentColor"
								viewBox="0 0 20 20"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fillRule="evenodd"
									d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
									clipRule="evenodd"
								></path>
							</svg>
						</div>
						<input
							type="text"
							className="block p-1.5 pl-10 text-sm text-gray-900 border border-gray-300 rounded w-80 bg-gray-50 focus:outline-none"
							placeholder="Search for parking spaces"
							onChange={(e) => search(e.target.value)}
						/>
					</div>
				</div>

				{/* table */}
				<div className="w-full overflow-x-auto shadow-md sm:rounded">
					<div className="overflow-hidden min-w-max">
						<table className="w-full text-sm text-left text-gray-500">
							<thead className="text-xs text-gray-700 uppercase bg-gray-50">
								<tr>
									<th scope="col" className="px-6 py-3">
										Name
									</th>
									<th scope="col" className="px-6 py-3">
										City
									</th>
									<th scope="col" className="px-6 py-3">
										Details
									</th>
								</tr>
							</thead>

							<tbody className="">
								{(searchValue === "" ? allPsData.allData : filteredPS).map(
									({ id, name, city }, index) => (
										<tr
											key={index}
											className="bg-white border-b hover:bg-gray-50"
										>
											<th
												scope="row"
												className="px-6 py-4 font-medium text-darker whitespace-nowrap"
											>
												{name}
											</th>
											<td className="px-6 py-4">{city}</td>
											<td className="px-6 py-4">
												<p
													className="text-blue-400 hover:underline flex items-center w-fit
														cursor-pointer
														"
													onClick={() => navigate(`/revenue/ps/${id}`)}
												>
													<RxOpenInNewWindow />
													&nbsp; details
												</p>
											</td>
										</tr>
									)
								)}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	);
}
